// JavaScript code for sn/menus/mobile-menu component
(($) => {

    "use strict";
    if (!$('.sn-menus-mobile-menu').length) {
        return;
    }
    console.log("sn/menus/mobile-menu scripts loaded...");

    let originalMobileMenuHeight = 0;
    const mobileMenuHeightStack = [];

    $(function () {
        $(document).on('sn:mobileMenuToggled', function( e, data ) {
            if ( !data.isOpen ) {
                $('.sn-menus-mobile-menu .mobile-menu ul.sub-menu').removeClass('active');
            }
            originalMobileMenuHeight = $('.sn-menus-mobile-menu .mobile-menu').outerHeight();
        });

        $('.sn-menus-mobile-menu .mobile-menu').on('click', '.has-children > a', function (e) {
            e.preventDefault();
            $(this).next('ul').addClass('active');
            let previousHeight = $(this).closest('ul').outerHeight();
            mobileMenuHeightStack.push(previousHeight);
            let nextHeight = $(this).next('ul').outerHeight();
            adjustMobileMenuHeight(nextHeight);
        });

        $('.sn-menus-mobile-menu .mobile-menu .btn-back').on('click', function (e) {
            e.preventDefault();
            $(this).closest('ul').removeClass('active');
            let previousHeight = mobileMenuHeightStack.pop();
            adjustMobileMenuHeight(previousHeight);
        });

        function adjustMobileMenuHeight(newHeight) {
            if (newHeight < originalMobileMenuHeight) {
                newHeight = originalMobileMenuHeight;
            }

            $('.sn-menus-mobile-menu .container-mobile-menu').animate({
                height: newHeight + 'px'
            }, 300);
        }
    });

})(jQuery);